import { useEffect } from 'react';

import { useSaveCurrentUserInfo, useSelectCurrentUserInfo } from '@treneo/features/user';
import type { ISaveCurrentUserInfoRequest } from '@treneo/models';

import { MyAccountForm } from './my-account-form';

type Props = {
  onClose: () => void;
};

export const MyAccountFormContainer = ({ onClose }: Readonly<Props>) => {
  const currentUserInfo = useSelectCurrentUserInfo();
  const saveCurrentUserInfoMutation = useSaveCurrentUserInfo();

  const handleSubmit = (formData: ISaveCurrentUserInfoRequest) => {
    saveCurrentUserInfoMutation.mutate({
      firstName: formData.firstName,
      lastName: formData.lastName,
      displayName: formData.displayName,
      avatarColor: formData.avatarColor,
      timezone: formData.timezone
    } as ISaveCurrentUserInfoRequest);
  };

  useEffect(() => {
    let timeout: number | undefined;
    if (saveCurrentUserInfoMutation.isSuccess) {
      timeout = window.setTimeout(() => {
        onClose();
      }, 2000);
    }

    return () => {
      if (timeout) {
        window.clearTimeout(timeout);
      }
    };
  }, [saveCurrentUserInfoMutation.isSuccess, onClose]);

  return (
    <MyAccountForm
      onSubmit={handleSubmit}
      email={currentUserInfo?.email}
      firstName={currentUserInfo?.firstName}
      lastName={currentUserInfo?.lastName}
      displayName={currentUserInfo?.displayName}
      avatarColor={currentUserInfo?.avatarColor}
      timezone={currentUserInfo?.timezone}
      isSubmitSuccess={saveCurrentUserInfoMutation.isSuccess}
      isLoading={saveCurrentUserInfoMutation.isPending}
    />
  );
};
